import { render, staticRenderFns } from "./AsPerCOA.vue?vue&type=template&id=470060d9&"
import script from "./AsPerCOA.vue?vue&type=script&lang=js&"
export * from "./AsPerCOA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports